import {getHostVariables} from '../utils';
import {allLogTypes as logTypes} from '@servicenow/ui-internal';

import {onAction} from './onAction';
import {onActionHoisted} from './onActionHoisted';
import {addActionHandler} from './customEventActionHandler';
import {isHoisted, getHoistTarget} from './utils';
import {RETARGETED_ACTION_TYPES, TARGETED_ACTION_TYPES} from '../symbols';
import {SEISMIC_HOIST_TAG_NAME} from '../constants';
import log from '../log';

function resolveCaptureHandlerMetaData(interceptors) {
	const {length: interceptorCount} = interceptors;
	for (let i = 0; i < interceptorCount; i++) {
		const {capture, eventHandler} = interceptors[i];
		if (capture !== undefined && eventHandler !== undefined) return {capture, eventHandler};
	}
	return {capture: false, eventHandler: false};
}

export function addActionHandlers(host, actions) {
	const handlers = [];
	const hoisted = isHoisted(host);
	const hostVariables = getHostVariables(host);

	if (actions[undefined]) {
		log(
			'You are registering an action handler for a type that is: undefined.  We will send undefined actions to the upside down place in the next release.',
			{level: logTypes.WARN, host, origin: 'addActionHandlers'}
		);
	}

	for (const k in actions) {
		actions[k].forEach(function forEachTarget(interceptors, targetSelector) {
			const {capture, eventHandler} = resolveCaptureHandlerMetaData(interceptors);
			const resolvedTarget =
				targetSelector === 'host'
					? host
					: typeof targetSelector === 'string'
					? document.querySelector(targetSelector)
					: targetSelector;

			if (hoisted) {
				const hoistElem = getHoistTarget(hostVariables);
				if (hoistElem.tagName === SEISMIC_HOIST_TAG_NAME) {
					const hoistElemVariables = getHostVariables(hoistElem);
					handlers.push(
						addActionHandler(
							hoistElem,
							targetSelector,
							host,
							k,
							capture,
							eventHandler,
							onActionHoisted
						)
					);
					hoistElemVariables[RETARGETED_ACTION_TYPES] = [
						...hoistElemVariables[RETARGETED_ACTION_TYPES],
						k
					];
				}
			}
			handlers.push(
				addActionHandler(resolvedTarget, targetSelector, host, k, capture, eventHandler, onAction)
			);
			hostVariables[TARGETED_ACTION_TYPES] = [...hostVariables[TARGETED_ACTION_TYPES], k]; // eslint-disable-line no-param-reassign
		});
	}

	return handlers;
}
